/**
 * MAP MARKERS IS FOR USE WHEN WE JUST DISPLAYING MARKERS NOT PICKING LOCATIONS
 */

import { Component, Input, NgZone, OnInit } from '@angular/core';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { IMapMarker } from '@boma/client-shared';

declare const google: any;

// TODO: Confirm if this is needed otherwise remove.
@Component({
  selector: 'boma-map-markers',
  templateUrl: './map-markers.component.html',
  styleUrls: ['./map-markers.component.scss'],
})
export class MapMarkersComponent implements OnInit {
  latitude: number = null;
  longitude: number = null;

  private map: google.maps.Map;
  private markerClusterer: MarkerClusterer;

  @Input() zoom = 8;
  @Input() height = '400px';
  @Input() mapCenter: IMapMarker = null;
  @Input() location = null; //[long, lat] // Todo convert to imap marker
  // @Input() markers: IMapMarker[] = [];

  markerPlain = {
    url: 'assets/layout/images/interface/maps/pin-plain.svg',
    scaledSize: { height: 60, width: 60 },
  };

  options = {
    styles: [
      {
        textColor: 'white',
        url: '',
        height: 40,
        width: 40,
        textSize: 16,
        backgroundPosition: '50% 50%',
        backgroundSize: 'contain',
      },
    ],
  };

  // Define your markers
  markers = [
    {
      position: {
        lat: 37.775,
        lng: -122.434,
      },
      label: {
        text: 'Marker 1',
        color: 'white',
        fontSize: '16px',
      },
    },
    {
      position: {
        lat: 37.775,
        lng: -122.435,
      },
      label: {
        text: 'Marker 2',
        color: 'white',
        fontSize: '16px',
      },
    },
    // Add more markers as needed
  ];

  constructor(private ngZone: NgZone) {}

  ngOnInit(): void {
    if (this.location) {
      this.longitude = this?.location[0];
      this.latitude = this?.location[1];
    }

    // Create an array of Google Maps markers
    const googleMarkers = this.markers.map((marker) => {
      return new google.maps.Marker({
        position: marker.position,
        label: marker.label,
      });
    });

    // Add the Google Maps markers to the MarkerClusterer
    this.markerClusterer.addMarkers(googleMarkers);
  }

  ngAfterViewInit() {
    // this.mapElement.mapReady.subscribe((map) => {
    //   this.ngZone.run(() => {
    //     this.map = map;
    //     this.markerClusterer = new MarkerClusterer(this.map, [], this.options);
    //   });
    // });
  }

  // Add markers to the clusterer
  addMarkers(markers: google.maps.Marker[]) {
    this.markerClusterer.addMarkers(markers); // add markers
  }
}
